import React from 'react';
import { SectionShell } from './SectionShell';
import { outcomes } from '../data/caseStudy';
export function Outcomes() {
  return <SectionShell number="07" title="Outcomes" tone="light" data-id="element-68" data-mp="1h856mp0qfyer">
      <div className="grid grid-cols-2 gap-16" data-id="element-69" data-mp="1m8b5oq9c0n6v">
        {outcomes.map(column => <div key={column.heading} data-id="element-70" data-mp="1r7nql5gn7k6t">
            <h3 className="border-t-2 border-ink pt-7 font-display text-3xl font-semibold tracking-tightest text-ink" data-id="element-71" data-mp="1r6l0gzr59lry">
              {column.heading}
            </h3>
            <ul className="mt-8 space-y-6" data-id="element-72" data-mp="yip5q0l4y3xt">
              {column.items.map(item => <li key={item} className="border-b border-ink/10 pb-6 text-lg leading-snug text-ink/80" data-id="element-73" data-mp="13ilba49he3fh">
                  {item}
                </li>)}
            </ul>
          </div>)}
      </div>

      <figure className="mt-16" data-id="element-74" data-mp="aufpde6oy8e2">
        <img src="https://cdn.magicpatterns.com/uploads/eErjWeoP9PTdrzLmimoo6C/landing_page_image.webp" alt="The new CreateFuture brand expression: “Create Tomorrow, Together, Today” set on the gradient visual language" className="h-[260px] w-full border border-ink/10 object-cover" style={{
        height: "450px"
      }} data-id="element-75" data-mp="at4ih5hy8kiq" />
        <figcaption className="mt-4 text-sm text-ink/55" data-id="element-76" data-mp="2y0hu859bkwdg">
          Brand expression at launch, one visual language across campaign and platform.
        </figcaption>
      </figure>

      <figure className="mt-12" data-id="element-77" data-mp="2p5lbom3pm7cx">
        <img src="https://cdn.magicpatterns.com/uploads/mzjpJXjq1z9tcZ8FsF3g11/Nektaria_Bogris_2025_projects4.png" alt="The delivered system in use: colour and typography foundations, the rebranded CreateFuture website and annotated page templates" className="w-full border border-ink/10 object-cover" data-id="element-78" data-mp="2k70bgmogjnoh" />
        <figcaption className="mt-4 text-sm text-ink/55" data-id="element-79" data-mp="268afjaddju1p">
          Delivered the website rebrand end to end, from discovery, wireframes, interactive prototypes, and high-fidelity designs through to developer handover and launch. Working closely with our in-house engineering team, I ensured the new digital experience was built to specification while creating reusable templates and guidance that enabled teams across the business to manage and evolve content independently.
        </figcaption>
      </figure>
    </SectionShell>;
}